import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Add this import
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import "./style.css";
import { fetchDataFromApi } from "../../utils/api";

const Catsliders = () => {
  const navigate = useNavigate(); // Add navigation hook
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const MIN_CATEGORIES_FOR_SLIDER = 9; 

  const [itembg] = useState([
    "#fffceb",
    "#ecffec",
    "#feefea",
    "#fff3eb",
    "#fff3ff",
    "#f2fce4",
    "#feefea",
    "#f1fceb",
    "#feefea",
    "#ecffec",
  ]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await fetchDataFromApi("/api/category");

        if (res?.categoryList && Array.isArray(res.categoryList)) {
          setCategories(res.categoryList);
        } else {
          console.warn(
            "API response for categories is not an array in categoryList or is empty:",
            res
          );
          setCategories([]);
        }
      } catch (err) {
        console.error("API Error fetching categories in Catsliders:", err);
        setError("Failed to load categories. Please try again later.");
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  // Add navigation function
  const handleCategoryClick = (category) => {
    console.log("Category clicked from slider:", category);
    
    // Navigate to listing page with category parameters
    const queryParams = new URLSearchParams({
      category: category._id,
      name: category.name
    }).toString();
    
    navigate(`/listing?${queryParams}`);
  };

  const settings = {
    dots: false,
    infinite: true, 
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 8 } },
      { breakpoint: 1024, settings: { slidesToShow: 7 } },
      { breakpoint: 768, settings: { slidesToShow: 5 } },
      { breakpoint: 480, settings: { slidesToShow: 3 } },
      { breakpoint: 320, settings: { slidesToShow: 2 } },
    ],
  };

  if (loading) {
    return (
      <div className="catslider-section py-4">
        <div className="container-fluid">
          <div className="catslider-grid">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="text-center">
                <div className="catslider-item-info skeleton">
                  <div className="skeleton-img-circle skeleton mb-2" />
                  <div className="skeleton-text skeleton" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="catslider-section text-center py-5">
        <p className="text-danger">{error}</p>
      </div>
    );
  }

  const renderCategoryItems = () => {
    return categories.map((category, index) => {
      const backgroundColor = itembg[index % itembg.length];
      const imageUrl =
        category.images && category.images.length > 0
          ? category.images[0]
          : "https://via.placeholder.com/150/EEEEEE/333333?text=No+Image";

      return (
        <div
          className="catslider-item row"
          key={category._id || `cat-${index}`}
          onClick={() => handleCategoryClick(category)} // Add click handler
          style={{ cursor: "pointer" }} // Add cursor pointer
        >
          <div
            className="catslider-item-info"
            style={{ background: backgroundColor }}
          >
            <LazyLoadImage
              alt={category.name || "Category image"}
              effect="blur"
              className="w-100 myimage"
              src={imageUrl}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "https://via.placeholder.com/150/EEEEEE/333333?text=Error";
              }}
            />
            <h5>{category.name}</h5>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="catslider-section">
      <div className="container-fluid">
        {categories.length === 0 ? (
          <div className="text-center mt-4">
            <p>No categories to display.</p>
          </div>
        ) : categories.length >= MIN_CATEGORIES_FOR_SLIDER ? (
          <Slider
            {...settings}
            className="catslider-main-slider"
            id="cat_slider_main"
          >
            {renderCategoryItems()}
          </Slider>
        ) : (
          <div className="catslider-grid">
            {renderCategoryItems()}
          </div>
        )}
      </div>
    </div>
  );
};

export default Catsliders;